import React, { useEffect, useState, useMemo } from "react";
import styles from "./index.module.css";
import MultiselectDropdown from "../MultiselectDropdown";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSelLocation } from "../../../store/slices/Products/dashboard.slice";
import {
  setAllProduct,
  setSearch,
} from "../../../store/slices/Products/product.slice";
import { locationMapping } from "../../../utils/constant";
import {
  setBrandData,
  setCurrency,
  setSource,
  setSubCategoryData,
} from "../../../store/slices/constants/constant.slice";
import { getSource, filterLocationsByOrg } from "../../../utils/helpers";
import Dropdown from "../Dropdown";
import { useLocation } from "react-router-dom";
import { setCompetitionTrens } from "../../../store/slices/analytics/analytics.slice";

const getMapping = (source) => {
  const temp = {};
  source.forEach((i) => {
    temp[locationMapping[i].location] = i;
  });
  return temp;
};
const currencys = ["NZD", "AUD", "SGD"];
const monthYearOptions = ["May 2025", "September 2025", "February 2026"];
const Header = React.memo(({ isDashboard, isProducts, onSearchChange, searchValue, onSourceChange, onMonthYearChange, selectedMonth, selectedYear, storeDropdown }) => {
  const userData = JSON.parse(localStorage.getItem("data"));
  const locationSteps = useSelector((store) => store.constant.location);
  const organizationId = useSelector((store) => store.user.organizationId);
  const userSource = userData.user_source.map(
    (i) => locationMapping[i].location
  );
  const locationSourceMapping = getMapping(userData.user_source);

  const { source, currency } = useSelector((store) => store.constant);
  
  const filteredLocationSteps = useMemo(() => {
    return filterLocationsByOrg(locationSteps, organizationId);
  }, [locationSteps, organizationId]);
  const [selectedSource, setSelectedSource] = useState(
    userData.user_source.indexOf(source)
  );
  const [selectedCurremcy, setSelectedCurrency] = useState(
    currencys.indexOf(currency)
  );
  
  const getMonthYearIndex = () => {
    if (selectedMonth === 5 && selectedYear === 2025) return 0;
    if (selectedMonth === 9 && selectedYear === 2025) return 1;
    if (selectedMonth === 2 && selectedYear === 2026) return 2;
    return 2; // default to February 2026 (current period)
  };
  const [selectedMonthYearIndex, setSelectedMonthYearIndex] = useState(getMonthYearIndex());

  // Update selected currency when currency changes in store
  useEffect(() => {
    setSelectedCurrency(currencys.indexOf(currency));
  }, [currency]);
  
  // Update selected month/year index when props change
  useEffect(() => {
    setSelectedMonthYearIndex(getMonthYearIndex());
  }, [selectedMonth, selectedYear]);

  const onSelectedMonthYear = (value, index) => {
    console.log(`📅 Dropdown changed to index: ${index} (type: ${typeof index}), value: ${value}`);
    console.log(`📅 onMonthYearChange exists:`, !!onMonthYearChange);
    const idx = parseInt(index);
    setSelectedMonthYearIndex(idx);
    if (onMonthYearChange) {
      if (idx === 0) {
        onMonthYearChange(5, 2025, 'May 2025');
      } else if (idx === 1) {
        onMonthYearChange(9, 2025, 'September 2025');
      } else if (idx === 2) {
        onMonthYearChange(2, 2026, 'February 2026');
      }
    }
  };

  const defaultSearch = useSelector((store) => store.products.search);
  const search = searchValue !== undefined ? searchValue : defaultSearch;
  const dispatch = useDispatch();
  const location = useLocation();

  const onSelectedLocationChange = (value) => {
    dispatch(setSelLocation(value));
  };
  const handleSearchInput = (e) => {
    if (onSearchChange) {
      onSearchChange(e);
    } else {
      dispatch(setSearch(e.target.value));
    }
  };

  const onSelectedSource = (value, index) => {
    setSelectedSource(index);
    dispatch(setAllProduct(-1));
    dispatch(setSubCategoryData([]));
    dispatch(setBrandData([]));
    dispatch(setCompetitionTrens({}));
    dispatch(setSource(locationSourceMapping[value]));
    
    // Call custom source change handler if provided
    if (onSourceChange) {
      onSourceChange(locationSourceMapping[value]);
    }
  };

  const onSelectedCurrency = (value, index) => {
    setSelectedCurrency(index);
    dispatch(setCurrency(value));
  };

  return (
    <div className={styles["header"]}>
      <div className={styles["left"]}>
        <h1>
          Welcome {userData.first_name} {userData.last_name}
        </h1>
      </div>

      {isProducts && (
        <div className={styles["search"]}>
          <i class="bi bi-search"></i>
          <input
            type="text"
            placeholder="Search Product"
            value={search}
            onChange={handleSearchInput}
          />
        </div>
      )}

      <div className={styles["right"]}>
        {isDashboard && (
          <div className={styles["filter"]}>
            {/* <div>
            <div>Location</div>
            <div>
              <i class="bi bi-pin"></i>
            </div>
          </div> */}
            <div className={styles["dropdown"]}>
              <MultiselectDropdown
                steps={filteredLocationSteps}
                onChange={onSelectedLocationChange}
                name="location"
              />
            </div>
          </div>
        )}

        <div className={styles["item"]}>
          {[
            "/dashboard/fnb-dashboard",
            "/dashboard/fnb-products",
            "/dashboard/fnb-reporting",
          ].includes(location.pathname) ? (
            <><div>{locationMapping[source].location}</div>
          <div>
            <i class="bi bi-pin"></i>
          </div></>
          ) : (
            <div>
              <Dropdown
                steps={userSource}
                selectedValue={selectedSource}
                onChange={onSelectedSource}
              />
            </div>
          )}
        </div>
        {[
          "/dashboard/fnb-dashboard",
          "/dashboard/fnb-products",
          "/dashboard/fnb-reporting",
        ].includes(location.pathname) && 
        storeDropdown?.show && 
        storeDropdown?.stores?.length > 0 && (
          <div className={styles["item"]}>
            <div className={styles["dropdown"]}>
              <MultiselectDropdown
                selSteps={storeDropdown.selectedStores && storeDropdown.selectedStores.length > 0 ? storeDropdown.selectedStores : storeDropdown.stores}
                steps={storeDropdown.stores}
                name="stores"
                onChange={storeDropdown.onChange}
              />
            </div>
          </div>
        )}
        {[
          "/dashboard/fnb-dashboard",
          "/dashboard/fnb-products",
          "/dashboard/fnb-reporting",
        ].includes(location.pathname) && (
          <div className={styles["item"]}>
            <div className={styles["monthYearDropdown"]}>
              <Dropdown
                steps={monthYearOptions}
                selectedValue={selectedMonthYearIndex}
                onChange={onSelectedMonthYear}
              />
            </div>
          </div>
        )}
        <div className={styles["item"]}>
          <div>
            <Dropdown
              steps={currencys}
              selectedValue={selectedCurremcy}
              onChange={onSelectedCurrency}
            />
          </div>
          {/* <div>
            <i class="bi bi-chevron-down"></i>
          </div> */}
        </div>
      </div>
    </div>
  );
});

export default Header;
